// Ink-on-transparent illustrations in /public/quote_art, tinted with the current text color via CSS mask.
export const ItemArt = ({ type, className = "" }) => {
  const url = `url(/quote_art/${type}.png)`;
  return (
    <span aria-hidden="true" className={`inline-block shrink-0 ${className}`} data-art={type}
      style={{ backgroundColor: "currentColor", WebkitMaskImage: url, maskImage: url, WebkitMaskSize: "contain", maskSize: "contain",
        WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat", WebkitMaskPosition: "center", maskPosition: "center" }} />
  );
};
